import actions from '../../actionTypes';

export default location => {
  return {
    type: actions.EDIT_LOCATION,
    location
  };
};



// WEBPACK FOOTER //
// ./src/reducers/locations/actions/locationEdit.js